import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-vue-next';
import template from './index.vdt';
import { sizes } from '../../styles/utils';
import { bind } from '../utils';
import { useDraggable } from './useDraggable';
import { useConfigContext } from '../config';
var typeDefs = {
  name: String,
  on: String,
  off: String,
  value: null,
  trueValue: null,
  falseValue: null,
  width: [Number, String],
  height: [Number, String],
  size: sizes,
  disabled: Boolean,
  loading: Boolean,
  beforeChange: Function
};
var defaults = function defaults() {
  return {
    value: false,
    trueValue: true,
    falseValue: false,
    size: 'default',
    loading: false
  };
};
var events = {
  click: true,
  keypress: true
};
export var Switch = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Switch, _Component);
  function Switch() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.elementRef = createRef();
    _this.draggable = useDraggable(_this.elementRef);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Switch.prototype;
  _proto.onClick = function onClick(e) {
    if (!e._switchIgnore) {
      this.toggle(false);
    }
    this.trigger('click', e);
  };
  _proto.onClickOnHandle = function onClickOnHandle(e) {
    // we can not stop propagation, otherwise the click can not be listen at outer
    var _this$get = this.get(),
      beforeChange = _this$get.beforeChange;
    e._switchIgnore = !beforeChange;
  };
  _proto.onKeypress = function onKeypress(e) {
    this.trigger('keypress', e);
    if (e.keyCode === 13) {
      this.toggle(true);
    }
  };
  _proto.toggle = /*#__PURE__*/function () {
    var _toggle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(isKeypress) {
      var _this$get2, disabled, beforeChange, value, trueValue, falseValue, toValue, ret;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$get2 = this.get(), disabled = _this$get2.disabled, beforeChange = _this$get2.beforeChange, value = _this$get2.value, trueValue = _this$get2.trueValue, falseValue = _this$get2.falseValue;
            if (!disabled) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            // if is not keypress, we blur it to remove focus style
            if (!isKeypress) {
              this.elementRef.value.blur();
            }
            if (!beforeChange) {
              _context2.next = 16;
              break;
            }
            this.set({
              disabled: true,
              loading: true
            });
            _context2.prev = 6;
            toValue = this.isChecked() ? falseValue : trueValue;
            _context2.next = 10;
            return beforeChange(value, toValue);
          case 10:
            ret = _context2.sent;
            if (ret) {
              _context2.next = 13;
              break;
            }
            return _context2.abrupt("return");
          case 13:
            _context2.prev = 13;
            this.set({
              disabled: false,
              loading: false
            });
            return _context2.finish(13);
          case 16:
            if (this.isChecked()) {
              this.uncheck();
            } else {
              this.check();
            }
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee, this, [[6,, 13, 16]]);
    }));
    function toggle(_x) {
      return _toggle.apply(this, arguments);
    }
    return toggle;
  }();
  _proto.isChecked = function isChecked() {
    return this.get('value') === this.get('trueValue');
  };
  _proto.check = function check() {
    this.set('value', this.get('trueValue'));
  };
  _proto.uncheck = function uncheck() {
    this.set('value', this.get('falseValue'));
  };
  return Switch;
}(Component);
Switch.template = template;
Switch.typeDefs = typeDefs;
Switch.defaults = defaults;
Switch.events = events;
__decorate([bind], Switch.prototype, "onClick", null);
__decorate([bind], Switch.prototype, "onClickOnHandle", null);
__decorate([bind], Switch.prototype, "onKeypress", null);